import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

/**
 * This function sets a CVID cookie in case there's no one already defined.
 * CVID is a uuidv4 string that serves as the user unique identifier.
 * https://chegg.atlassian.net/wiki/spaces/DEVX/pages/800136499/Chegg+Visitor+ID+Spec
 */
export function setCVID() {
  if (typeof window !== undefined && !Cookies.get('CVID')) {
    const CVID = uuidv4();
    /* TODO update urls to be tld aware */
    const domain = process.env.CHEGG_ENV === 'prod' ? 'chegg.com' : '.cheggnet.com';
    Cookies.set('CVID', CVID, { domain, expires: Infinity });
  }
}
